<template lang="pug">
  .share
    span.share__text Share to&nbsp;
      a.share__item facebook
      span ,&nbsp;
      a.share__item twitter
</template>

<script>
export default {
  name: 'Share',
};
</script>

<style lang="scss">
  .share {
    @include vertical-align;
    justify-content: center;
    &__item {
      @include main-link;
    }
    &__text {
      @include typo-p;
      color: $clr-darkMain;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UI/Share.vue